import "./App.css";
import Home from "./screens/Home";
import ComingSoon from "./screens/ComingSoon";
// import "tailwindcss/tailwind.css";
import { Routes, Route } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import SignUp from "./screens/SignUp";
import Login from "./screens/Login";
import About from "./screens/About";
import Disclaimer from "./screens/Disclaimer";
import Privacy from "./screens/Privacy";
import Refund from "./screens/Refund";
import Premium from "./screens/Premium";
import BuyUnits from "./screens/BuyUnits";
import Profile from "./screens/Profile";
import { AuthProvider } from "./global/auth-context";
import { ToastContainer } from "react-toastify";
import Convert from "./screens/Convert.js";
import DownloadApp from "./screens/DownloadApp.js";
import ForgotPassword from "./screens/ForgotPassword.js";
import ViewFreeGames from "./screens/ViewFreeGames.js";
import ViewPremiumGames from "./screens/ViewPremiumGames.js";
import { Analytics } from "@vercel/analytics/react";
import Menu from "./components/Menu.js";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  // Initialize Analytics and get a reference to the service

  function AppAds(params) {
    return "google.com, pub-3788803640944540, DIRECT, f08c47fec0942fa0";
  }

  return (
    <div className="bg-myLightGreen h-screen flex flex-col">
      <GoogleOAuthProvider clientId="1038087207541-4rgv8t3q8rq87itgna9fp3p0qa31n59d.apps.googleusercontent.com">
        <AuthProvider>
          <ToastContainer />
          <Analytics />

          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/test" element={<Home />} /> */}
              <Route path="/register" element={<SignUp />} />
              <Route path="/login" element={<Login />} />
              <Route path="/about" element={<About />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="/premium" element={<Premium />} />
              <Route path="/buy-units" element={<BuyUnits />} />
              <Route path="/Profile" element={<Profile />} />
              <Route path="/convert" element={<Convert />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/download-app" element={<DownloadApp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path={`/freeTips/:code`} element={<ViewFreeGames />} />
              <Route
                path={`/premiumTips/:code`}
                element={<ViewPremiumGames />}
              />
              {/* <Route path={`/app-ads.txt`} element={<AppAds />} /> */}
            </Routes>
          </Router>
        </AuthProvider>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
